import { Alert, Button, Icon, Text } from '@flatfile/baseline'
import React from 'react'
import { useActiveEnvironment } from '../../hooks/useEnvironments'

interface DeveloperTipAlertProps {
  learnMoreUrl: string
  children: React.ReactNode
}

const DeveloperTipAlert: React.FC<DeveloperTipAlertProps> = ({ learnMoreUrl, children }) => {
  // Assuming isProd is determined here. Adjust as per your application's environment handling
  const { environment } = useActiveEnvironment()

  if (environment.isProd) return null

  const handleLearnMoreClick = () => {
    window.open(learnMoreUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Alert className='mt-4 bg-overlay-darken-300 border-border'>
      <div className='space-y-3'>
        <div className='flex items-center gap-2'>
          <Icon name='code' size={18} />
          <Text variant='callout' className='font-semibold'>
            Developer Tip
          </Text>
        </div>

        <div className='space-y-2'>{children}</div>

        <div>
          <Button variant='outline' size='sm' icon='arrow-right' iconPlacement='right' onClick={handleLearnMoreClick}>
            Learn more
          </Button>
        </div>
      </div>
    </Alert>
  )
}

export default DeveloperTipAlert
